import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectFurniture = createSelector(selectJsonQuery, jsonQuery => getTermValue('has_furniture')(jsonQuery));
